import { createContext, useContext } from 'react';
import type { ITimesheetConnector } from '../types/connector.types';

const ConnectorContext = createContext<ITimesheetConnector | null>(null);

export const ConnectorProvider = ConnectorContext.Provider;

/** Use inside any hook or component that needs data access. */
export function useConnector(): ITimesheetConnector {
  const connector = useContext(ConnectorContext);
  if (!connector) {
    throw new Error(
      'useConnector must be used inside <ConnectorProvider>. ' +
        'Check that ConnectorContext is wired up in index.tsx.'
    );
  }
  return connector;
}
